export const FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
export const FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
export const FACETING_CLEAR_ALL = 'FACETING_CLEAR_ALL';
export const FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
export const FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
export const FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
export const FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
export const FACETING_SET_CUSTOM_FILTERS = 'FACETING_SET_CUSTOM_FILTERS';
export const FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
export const FACETING_SET_SEARCH_FILTERS = 'FACETING_SET_SEARCH_FILTERS';
export const FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
export const FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
export const FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
export const FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
export const FACETING_SET_ORDER_BY_PRICE = 'FACETING_SET_ORDER_BY_PRICE';
export const FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
export const FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
export const FACETING_RESET_CUSTOM_FILTERS = 'FACETING_RESET_CUSTOM_FILTERS';
export const FACETING_RESET_FILTERS = 'FACETING_RESET_FILTERS';
export const FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
export const FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
export const FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE =
  'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
export const FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
export const FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE =
  'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
export const FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON =
  'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
export const FACETING_UPDATE_CUSTOM_FILTERS = 'FACETING_UPDATE_CUSTOM_FILTERS';
export const FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';
export const FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING =
  'FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING';
export const FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS =
  'FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS';
